/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import classNames from 'classnames';
import { Text } from '../../atoms/Text';
import './TreeViewStyles.scss';
const BASE_CLASS = 'tree-view';
function getStatusIcon(status) {
    if (status === 'complete')
        return 'fa-solid fa-check';
    if (status === 'error')
        return 'fa-solid fa-xmark';
    if (status === 'running')
        return 'fa-light fa-loader';
    return '';
}
export function TreeView({ items, className }) {
    if (items.length === 0) {
        return React.createElement("div", { className: classNames(BASE_CLASS, className) });
    }
    return (React.createElement("div", { className: classNames(BASE_CLASS, className), role: "list" }, items.map((item, index) => {
        const isLast = index === items.length - 1;
        const statusIcon = getStatusIcon(item.status);
        return (React.createElement("div", { key: item.id, className: classNames(`${BASE_CLASS}__row`, { [`${BASE_CLASS}__row--last`]: isLast }), role: "listitem" },
            React.createElement("div", { className: `${BASE_CLASS}__connector` },
                React.createElement("div", { className: `${BASE_CLASS}__connector-line` })),
            React.createElement("div", { className: `${BASE_CLASS}__content` },
                React.createElement("div", { className: `${BASE_CLASS}__label-row` },
                    statusIcon && (React.createElement("i", { className: classNames(`${BASE_CLASS}__status-icon`, statusIcon, {
                            [`${BASE_CLASS}__status-icon--running`]: item.status === 'running',
                            [`${BASE_CLASS}__status-icon--complete`]: item.status === 'complete',
                            [`${BASE_CLASS}__status-icon--error`]: item.status === 'error'
                        }), "aria-hidden": "true" })),
                    React.createElement(Text, { variant: "x-small", className: `${BASE_CLASS}__label` }, item.label)),
                item.detail && (React.createElement(Text, { variant: "xx-small", className: `${BASE_CLASS}__detail` }, item.detail)))));
    })));
}
